module.exports = __webpack_public_path__ + "img/game-cards-are-here.49812357.png";